namespace Matrix.Data {
    export class SecurityMergeSourceColumns {
        static columnsKey = 'Data.SecurityMergeSource';
    }
}
